import ServiceDeskIcon from './component'

export default ServiceDeskIcon
